
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pay-by-signage/[lotId]",
      function () {
        return require("private-next-pages/pay-by-signage/[lotId]/index.js");
      }
    ]);
  